// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"95a5a26c0b849e4c","4661":"aa7ed8b47a9a70ba"}[chunkId] + ".css";
};